import React, { useEffect } from 'react';
import {
  Box,
  Typography,
  IconButton,
  Card,
  CardContent,
  Tooltip,
  useTheme
} from '@mui/material';
import {
  Facebook,
  Instagram,
  LinkedIn,
  YouTube,
  X
} from '@mui/icons-material';
import { FaCogs, FaDiscord } from 'react-icons/fa';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { useNavigate } from 'react-router-dom';
import Footer2 from '../Footer/Footer2';
import Header1 from '../Header/Header1';

const Community = ({ userId, loggedIn, onLogout }) => {
  const theme = useTheme();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleLogout = () => {
    onLogout();
    navigate('/login');
  };

  const socialLinks = [
    { icon: <FaDiscord size={40} />, label: 'Discord', url: 'https://discord.gg/9PFJf4gBJ8' },
    { icon: <Facebook fontSize="large" />, label: 'Facebook', url: 'https://www.facebook.com/share/15Bjr5WUt9/' },
    { icon: <LinkedIn fontSize="large" />, label: 'LinkedIn', url: 'https://www.linkedin.com/company/anthrasync-solutions-private-limited/' },
    { icon: <Instagram fontSize="large" />, label: 'Instagram', url: 'https://www.instagram.com/anthrasync/' },
    { icon: <X fontSize="large" />, label: 'X (formerly Twitter)', url: 'https://x.com/anthrasync' },
    { icon: <YouTube fontSize="large" />, label: 'YouTube', url: 'https://www.youtube.com/@AnthrasyncMarketing' },
  ];

  const handleClick = (url) => {
    window.open(url, '_blank');
  };

  return (
    <Box
      sx={{
        background: 'linear-gradient(to right, #000000, #000000ff)',
        minHeight: '100vh',
        paddingTop: '100px',
        paddingX: { xs: 2, sm: 4 },
        color: 'white',
        overflow: 'hidden'
      }}
    >
      <Header1 />

      {/* Heading Section */}
      <Box textAlign="center" mb={6}>
        <Typography
          variant="h3"
          sx={{
            color: '#fff',
            fontWeight: 600,
            letterSpacing: 6,
            fontSize: { xs: '2rem', sm: '3rem', md: '3rem' },
            background: 'linear-gradient(to right, #00c6ff, #0072ff)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
        >
          Join Our Community
        </Typography>
        <Typography
          variant="h6"
          sx={{
            color: '#ccc',
            mt: 2,
            letterSpacing: 3,
            fontSize: { xs: '1rem', sm: '1.2rem' },
          }}
        >
          Connect with us on various platforms and stay updated.
        </Typography>
      </Box>

      {/* Cards Section using Box */}
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: 4,
          mb: 10
        }}
      >
        {socialLinks.map((social, index) => (
          <Box
            key={index}
            sx={{
              width: { xs: '100%', sm: '48%', md: '30%', lg: '22%' },
            }}
          >
            <Card
              onClick={() => handleClick(social.url)}
              sx={{
                backdropFilter: 'blur(10px)',
                background: 'rgba(255, 255, 255, 0.05)',
                borderRadius: '20px',
                textAlign: 'center',
                boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
                cursor: 'pointer',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                '&:hover': {
                  transform: 'scale(1.05)',
                  boxShadow: '0 12px 40px rgba(0,0,0,0.5)'
                }
              }}
            >
              <CardContent>
                <IconButton
                  sx={{
                    backgroundColor: '#000',
                    color: '#ffffffff',
                    p: 2,
                    borderRadius: '50%',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      backgroundColor: '#1a1a1a',
                      color: '#fff',
                    }
                  }}
                >
                  {social.icon}
                </IconButton>
                <Typography
                  variant="h6"
                  sx={{
                    mt: 2,
                    color: '#fff',
                    letterSpacing: 3,
                    fontSize: { xs: '1.2rem', sm: '1.5rem' },
                  }}
                >
                  {social.label}
                </Typography>
              </CardContent>
            </Card>
          </Box>
        ))}
      </Box>

      {/* Scroll to Top */}
      <Tooltip title="Scroll to Top">
        <IconButton
          onClick={scrollToTop}
          sx={{
            position: 'fixed',
            bottom: 20,
            right: 20,
            backgroundColor: '#000000ff',
            color: 'white',
            borderRadius: '50%',
            boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
            '&:hover': {
              backgroundColor: '#0072ff'
            }
          }}
        >
          <ArrowUpwardIcon />
        </IconButton>
      </Tooltip>

      <Footer2 />
    </Box>
  );
};

export default Community;
